import facebook from '../../assets/icons/facebookPublic.svg';
import linkedin from '../../assets/icons/linkedinPublic.svg';
import email from '../../assets/icons/Mail.svg';
import phone from '../../assets/icons/phone.svg';
import twitter from '../../assets/icons/twitterPublic.svg';
import url from '../../assets/icons/url.svg';
import social from '../../assets/social.svg';
import {
  Button,
  FormContainer,
  Input,
  TextArea,
  Typography,
} from '../../designComponents';
import { ContactForm, FormSectionWrapperStyled, ReachOut } from './style';
type Props = {};

const FormSection = (_props: Props) => {
  return (
    <div style={{ width: '100%' }}>
      <FormSectionWrapperStyled>
        <ReachOut>
          <Typography
            style={{ maxWidth: '480px', fontWeight: '600' }}
            size={32}
          >
            <span style={{ color: '#1D8960', lineHeight: '40px' }}>
              Contact Form
            </span>
            : <span style={{ color: '#20435D' }}>Reach Out to Us</span>
          </Typography>
          <Typography style={{ maxWidth: '480px' }}>
            Thank you for your interest in EscapePlan! If you have any questions
            or inquiries, please don't hesitate to get in touch with us.
          </Typography>
          <div className="contact">
            <div className="contact-number">
              <img src={phone} alt="phone icon" />
              <Typography style={{ width: '150px' }}>Contact Number</Typography>
              <Typography>9821111111</Typography>
              <Typography>9821111111</Typography>
            </div>
            <div className="contact-number">
              <img src={email} alt="email icon" />
              <Typography>Email address</Typography>
              <Typography>escapeplan@gmail.com</Typography>
              <Typography>escapeplan@gmail.com</Typography>
            </div>
            <div className="contact-number">
              <img src={url} alt="url icon" />
              <Typography>URL</Typography>
              <Typography>escapeplan.ie</Typography>
            </div>
            <div className="contact-number">
              <img src={social} alt="social icon" />
              <Typography style={{ width: '150px' }}>Social Media</Typography>
              <div className="social-icons">
                <img src={facebook} alt="facebook image" />
                <Typography>Facebook</Typography>
              </div>
              <div className="social-icons">
                <img src={linkedin} alt="linkedin icon" />
                <Typography>Linkedin</Typography>
              </div>
              <div className="social-icons">
                <img src={twitter} alt="twitter icon" />
                <Typography>Twitter</Typography>
              </div>
            </div>
          </div>
        </ReachOut>

        <ContactForm>
          <FormContainer label="First Name">
            <Input placeholder="Enter your first name" />
          </FormContainer>
          <FormContainer label="Last Name">
            <Input placeholder="Enter your last name" />
          </FormContainer>

          <FormContainer label="Email">
            <Input placeholder="Enter your email address" />
          </FormContainer>
          <FormContainer label="Phone Number">
            <Input placeholder="Enter your phone number" />
          </FormContainer>

          <FormContainer label="Message" className="msg">
            <TextArea
              placeholder="Write your message here"
              onChange={() => {}}
            />
          </FormContainer>
          <Button style={{ borderRadius: '28px' }}>submit</Button>
        </ContactForm>
      </FormSectionWrapperStyled>
    </div>
  );
};

export default FormSection;
